var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('user-share-card',{attrs:{"share-data":_vm.shareData,"share-id":_vm.id}}),(_vm.isPc)?_c('pc-app-downloader'):_c('mobile-app-downloader',{attrs:{"android-app-schema":_vm.appSchema,"ios-app-schema":_vm.appSchema,"copy-text":_vm.appSchema}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }